import { useEffect } from "react";
import { useRemoveTargetListMutation } from "../../../../features/targetlistApi";
import { addBannerWithTimeout } from "../../../lib/centralizedBanner/slice";
import { useAppDispatch } from "../../../lib/redux/hooks";
import { ConfirmModal } from "../../../ui/organisms/confirmModal.tsx";

export function DeleteTargetList({ id, setId, showModal, setShowModal }: { id?: string, setId: (id: string) => void, showModal: boolean, setShowModal: (show: boolean) => void }) {
    const dispatch = useAppDispatch();

    const [removeTargetList, {
        isLoading,
        reset
    }] = useRemoveTargetListMutation();

    useEffect(() => {
        return () => {
            reset();
        };
    }, [reset]);

    const handleCloseDeleteModal = () => {
        setShowModal(false);
        setId("");
        reset();
    };

    const handleDeleteConfirm = async () => {
        try {
            await removeTargetList(id!).unwrap();
            handleCloseDeleteModal();
            dispatch(addBannerWithTimeout({
                message: "Lista target eliminata con successo",
                variant: "success"
            }));

        } catch (error: any) {
            handleCloseDeleteModal();
            dispatch(addBannerWithTimeout({
                message: "Si è verificato un errore durante l'eliminazione",
                variant: "error"
            }));
        }
    };

    return (
        <ConfirmModal
            key={"delete-people-modal"}
            title={"Elimina lista target"}
            loading={isLoading}
            label={"Sei sicuro di voler eliminare questa lista target?"}
            confirmAction={handleDeleteConfirm}
            onClose={handleCloseDeleteModal}
            visible={showModal}
        />
    )
}